import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import Redux from './redux/';
import ReduxThunk from 'redux-thunk';
import ReduxPromise from 'redux-promise';
import QuoteFlowForm from './QuoteFlowForm';

let store = null;

if (process.env.NODE_ENV === 'development') {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  store = createStore(
    Redux.reducer,
    composeEnhancers(applyMiddleware(require('redux-freeze'), ReduxPromise, ReduxThunk))
  );
} else {
  store = createStore(Redux.reducer, applyMiddleware(ReduxPromise, ReduxThunk));
}

const quoteFlowAppDomElement = document.getElementById("quote-flow");
const QuoteFlowApp = () => {
  return (
    <Provider store={store}>
      <QuoteFlowForm />
    </Provider>
  );
};

export default QuoteFlowApp;

const getCityLabel = (cookiedFormData, fieldName) => {
  let cityLabel = '';
  if (typeof cookiedFormData[fieldName] === "string" && cookiedFormData[fieldName].length > 0) {
    cookiedFormData[fieldName] = JSON.parse(cookiedFormData[fieldName]);
  }

  if (cookiedFormData[fieldName].City) {
    cityLabel += cookiedFormData[fieldName].City;
  }
  if (cookiedFormData[fieldName].State) {
    cityLabel += `, ${cookiedFormData[fieldName].State}`;
  }
  return cityLabel;
}

const populateCookieData = () => {
  return new Promise((resolve, reject) => {
    var businessTypeQueryString = getURLParam("BusinessType");
    let cookiedFormData = sessionStorage.getItem('pods-quote-flow-form');
    if (cookiedFormData) {
      cookiedFormData = JSON.parse(cookiedFormData);
      if (businessTypeQueryString) {
        cookiedFormData.serviceType = businessTypeQueryString;
      }    
    }

    window.quoteFlowContent.Steps.map((step) => {
      step.Input.map((option) => {
        if ((cookiedFormData && (cookiedFormData[option.Name] && (!option.Value) || option.Name == "moveType"))) {
          option.Value = cookiedFormData[option.Name];
        } else if ((cookiedFormData && cookiedFormData[option.Name]) && option.Value.constructor === Array && option.Name !== 'quoteTypeLink') {
          if (option.Name.toLowerCase().indexOf('city') > -1) {
            option.Value = [{ Label: getCityLabel(cookiedFormData, option.Name), Value: cookiedFormData[option.Name], Selected: true }]
          } else {
            option.Value.map((opt) => {
              if (opt.Value === cookiedFormData[option.Name]) {
                opt.Selected = true;
              } else {
                opt.Selected = false;
              }
            })
          }
        }
      });
    });
    resolve();
  });
}

const startRenderingReact = () => {
  if (quoteFlowAppDomElement) {
    ReactDOM.render(<QuoteFlowApp />, quoteFlowAppDomElement);
  }
}

if (window.quoteFlowContent) {
  populateCookieData().then(startRenderingReact);
}

function getURLParam(param) {
  const half = location.search.split(param + '=')[1];
  return half !== undefined ? decodeURIComponent(half.split('&')[0]) : null;
}